import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ArrowLeft } from 'lucide-react';

/**
 * Shell for account-level pages that render outside the company layout —
 * /privacy, /company-closures, /connected-apps and the two MCP screens.
 *
 * They have no sidebar or company header (there may be no company, or no
 * login at all), so this gives them one slim brand bar with a way back, and a
 * centred column in which the ordinary in-app pieces (PageHeader,
 * SettingsCard, tables, EmptyState) look exactly as they do inside the app.
 *
 * `width`: 'wide' for list pages, 'narrow' for the consent/decision screens.
 * `back`:  { to, label } — defaults to company selection when signed in and
 *          the login page otherwise.
 */
export default function AccountPage({ width = 'wide', back, children }) {
    const signedIn = useSelector(state => state?.auth?.isAuthenticated);
    const email = useSelector(state => state?.auth?.user?.email);
    const link = back || (signedIn ? { to: '/select-company', label: 'Till företagsval' } : { to: '/login', label: 'Logga in' });
    return <div className={`account-page account-page--${width}`}>
        <header className="account-page__bar">
            <div className="account-page__bar-inner">
                <Link to={signedIn ? '/select-company' : '/login'} className="account-page__brand">LedgerLoop</Link>
                <div className="account-page__user">
                    {signedIn && typeof email === 'string' && <span className="account-page__user-email" title={email}>{email}</span>}
                    <Link to={link.to} className="account-page__link"><ArrowLeft size={14} strokeWidth={2} aria-hidden="true" />{link.label}</Link>
                </div>
            </div>
        </header>
        <main className="account-page__main">{children}</main>
    </div>;
}
